import { BUSINESS_APPROVAL_STATUSES } from '../stores/approvalsStore';
export function getBusinessApprovalIcon(status) {
  switch (status) {
    case BUSINESS_APPROVAL_STATUSES.Approved:
      return 'success';
    case BUSINESS_APPROVAL_STATUSES.Returned:
      return 'error';
    case BUSINESS_APPROVAL_STATUSES.Submitted:
    case BUSINESS_APPROVAL_STATUSES['In Review']:
      return 'info';
    default:
      return 'symbol unavailable';
  }
}
export function getBusinessApprovalIconColor(status, element) {
  switch (status) {
    case BUSINESS_APPROVAL_STATUSES.Approved:
      return getComputedStyle(element).getPropertyValue('--c360-g-color-palette-green-50');
    case BUSINESS_APPROVAL_STATUSES.Returned:
      return getComputedStyle(element).getPropertyValue('--c360-g-color-palette-red-40');
    case BUSINESS_APPROVAL_STATUSES.Submitted:
    case BUSINESS_APPROVAL_STATUSES['In Review']:
      return getComputedStyle(element).getPropertyValue('--c360-g-color-palette-cloud-blue-50');
    default:
      return 'color unavailable';
  }
}
export function getBusinessApprovalStatus(listingBusinessApprovalStatus) {
  switch (listingBusinessApprovalStatus) {
    case undefined:
      return BUSINESS_APPROVAL_STATUSES.Draft;
    case 'Approved Pending Compliance':
      return BUSINESS_APPROVAL_STATUSES.Approved;
    default:
      return BUSINESS_APPROVAL_STATUSES[listingBusinessApprovalStatus];
  }
}